import * as services from '@/services'
import ws from '@/utils/web-storage'
import router from '@/router'

const defineAccessToken = () => ws.get('access-token') || null

export default {
  namespaced: true,

  state: {
    accessToken: defineAccessToken(),

    isInitialLoading: false
  },

  getters: {
    isAuthorized: (state, _, rootState) => {
      if (!state.accessToken) return false
      if (rootState.user.user === null) return null

      return true
    }
  },

  actions: {
    async LOGIN({ commit }, { payload, type }) {
      if (!type) {
        throw new Error('Login type is required')
      }

      const handler =
        type === 'email'
          ? services.auth.loginWithEmail
          : services.auth.loginWithSocial

      const result = await handler(payload)

      const { isSuccess, content } = result

      if (!isSuccess) return result

      await Promise.all([
        commit('SET_ACCESS_TOKEN', {
          accessToken: content.accessToken,
          accessTokenExpiresAt: content.accessTokenExpiresAt
        }),
        commit('user/SET_USER', content.user, { root: true })
      ])

      window?.datafast('identify', {
        user_id: content.user._id,
        name: content.user.name,
        email: content.user.email,
        isPremium: content.user.isPremium
      })

      return result
    },

    async FETCH_ONE_USER_BY_ACCESS_TOKEN({ commit, dispatch }) {
      let result = {}

      try {
        commit('SET_IS_INITIAL_LOADING', true)

        result = await services.users.getOneByAccessToken()
        const { isSuccess, content } = result

        if (!isSuccess) {
          dispatch('LOGOUT')
          return result
        }

        await commit('user/SET_USER', content.user, { root: true })

        window?.datafast('identify', {
          user_id: content.user._id,
          name: content.user.name,
          email: content.user.email,
          isPremium: content.user.isPremium
        })
      } catch (error) {
        console.error(error)
        dispatch('LOGOUT')
      } finally {
        commit('SET_IS_INITIAL_LOADING', false)
      }

      return result
    },

    CHECK_IS_USER_AUTHORIZED({ dispatch }) {
      const accessToken = defineAccessToken()

      if (!accessToken) return

      return dispatch('FETCH_ONE_USER_BY_ACCESS_TOKEN')
    },

    async LOGOUT({ commit }) {
      await Promise.all([
        commit('CLEAR_ACCESS_TOKEN'),
        commit('user/SET_USER', null, { root: true })
      ])

      router.push({ name: 'home' })
    }
  },

  mutations: {
    SET_ACCESS_TOKEN(state, { accessToken, accessTokenExpiresAt }) {
      state.accessToken = accessToken

      const expiresAt = new Date(accessTokenExpiresAt).getTime()

      ws.set('access-token', accessToken, { expiresAt })
    },
    CLEAR_ACCESS_TOKEN(state) {
      state.accessToken = null

      ws.remove('access-token')
    },

    SET_IS_INITIAL_LOADING(state, isInitialLoading) {
      state.isInitialLoading = isInitialLoading
    }
  }
}
